const rankings = [
  { title: '头部主播人设崩塌事件全记录', source: '综合整理自911爆料网、51爆料网及匿名投稿', tag: 'HOT' },
  { title: '娱乐圈某经纪公司阴阳合同内幕', source: '匿名人士提供多份内部文件，编辑团队已核实', tag: 'NEW' },
  { title: '网红餐饮品牌卫生问题暗访调查', source: '独家暗访拍摄，多地市场监管部门已介入', tag: 'HOT' },
  { title: '顶流艺人团队集体出走完整始末', source: '多方信源交叉验证，涵盖当事人、团队及合作方', tag: 'NEW' },
  { title: '直播带货数据造假产业链深度揭秘', source: '前MCN机构高管匿名爆料，附详细操作流程', tag: 'HOT' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950">热度榜单</h2>
          <p className="text-foreground-500 text-sm mt-1">今日最受关注的爆料内容排行</p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {rankings.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              className="group flex items-stretch gap-4 md:gap-6 p-4 md:p-5 rounded-2xl bg-background-100 hover:bg-accent-50 transition-colors border border-background-200/70 hover:border-accent-200/50"
            >
              <div className="flex items-center shrink-0">
                <span className="w-10 h-10 md:w-12 md:h-12 rounded-xl border-2 border-background-300 group-hover:border-accent-300 flex items-center justify-center text-foreground-300 text-lg md:text-xl font-bold font-label transition-colors group-hover:text-accent-500">
                  {i + 1}
                </span>
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-foreground-900 font-bold text-sm md:text-lg leading-snug">{item.title}</h3>
                  <span className={`shrink-0 px-1.5 py-0.5 rounded text-[10px] font-semibold ${item.tag === 'HOT' ? 'bg-accent-100 text-accent-700' : 'bg-foreground-100 text-foreground-600'}`}>
                    {item.tag}
                  </span>
                </div>
                <p className="text-foreground-500 text-xs md:text-sm">{item.source}</p>
              </div>
              <div className="hidden md:flex items-center shrink-0">
                <i className="ri-arrow-right-line text-foreground-300 group-hover:text-accent-500 transition-colors w-5 h-5 flex items-center justify-center"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}